import { LegacyInput, LegacyOutput } from '@allocab/allocab-commons-shared-types';
import { useMutation } from '@tanstack/react-query';

import { silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

const convertLegacySession = (input: LegacyInput) =>
  passengerApi.post<LegacyInput, LegacyOutput>('/authentication/v1/user/login-legacy', input);

export const useConvertLegacySession = () =>
  useMutation<LegacyOutput, unknown, LegacyInput>({
    mutationFn: convertLegacySession,
    onError: silentQueryErrorHandler,
  });
